 ko.subscribable.fn['subscribeChange'] = (callback) ->
      savedValue = @.peek()
      return @subscribe (newVal) ->
         oldVal = savedValue
         savedValue = newVal
         callback(newVal, oldVal)